














import Vue from 'vue';
import automated from '../assets/features/automated.svg';
import flexible from '../assets/features/flexible.svg';
import moderated from '../assets/features/moderated.svg';
import opensource from '../assets/features/opensource.svg';
import reactive from '../assets/features/reactive.svg';
import simple from '../assets/features/simple.svg';

export default Vue.extend({
  data() {
    return {
      moderated,
      reactive,
      flexible,
      simple,
      automated,
      opensource
    };
  }
});
